import React from "react";
import { Backdrop, CircularProgress, Box, Typography, BackdropRoot } from "@mui/material";

const Loader = ({ open = true, message = "Loading..." }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.7)", // Dim background
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="inherit" />
        {message && (
          <Typography
            variant="body1"
            sx={{
              mt: 2,
              color: "white",
              fontFamily: "PRe",
              textAlign: "center",
            }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
};

export default Loader;



// import React, { useEffect } from 'react';
// import './index.css';

// const AppLoader = () => {
//   useEffect(() => {
//     // Disable scrolling on mount
//     document.body.style.overflow = 'hidden';

//     // Re-enable scrolling when component unmounts
//     return () => {
//       document.body.style.overflow = 'auto';
//     };
//   }, []);

//   return (
//     <div className="loader-overlay">
//       <div className="loader">
//         <div className="spinner"></div>
//       </div>
//     </div>
//   );
// };

// export default AppLoader;
